// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"26":"cbeaf570","819":"99caffaf"}[chunkId] + ".chunk.css";
};